(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-newsletter-section]').forEach(function (wrapper) {
      var form = wrapper.querySelector('.newsletter-form');
      if (!form || form.dataset.cnBound) return;
      form.dataset.cnBound = 'true';
      var email = form.querySelector('input[type="email"]');
      var button = form.querySelector('button[type="submit"]');
      var error = document.getElementById('Newsletter-error--' + wrapper.dataset.sectionId);
      var success = document.getElementById('Newsletter-success--' + wrapper.dataset.sectionId);
      function finish(accepted) {
        button.disabled = false;
        form.removeAttribute('aria-busy');
        if (error) error.style.display = accepted ? 'none' : 'block';
        if (success) success.style.display = accepted ? 'block' : 'none';
        var message = accepted ? success : error;
        if (message) message.focus();
      }
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (button.disabled || !form.checkValidity()) return;
        var siteId = wrapper.dataset.klaviyoSiteId;
        var listId = wrapper.dataset.klaviyoListId;
        if (!siteId || !listId) { finish(false); return; }
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        if (error) error.style.display = 'none';
        if (success) success.style.display = 'none';
        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Charcutnuvo inline newsletter',
              profile: {data: {type: 'profile', attributes: {
                email: email.value.trim(),
                subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
              }}}
            },
            relationships: {list: {data: {type: 'list', id: listId}}}
          }
        };
        var request = new XMLHttpRequest();
        request.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(siteId), true);
        request.setRequestHeader('Content-Type', 'application/vnd.api+json');
        request.setRequestHeader('Accept', 'application/vnd.api+json');
        request.setRequestHeader('revision', '2026-07-15');
        request.timeout = 15000;
        request.onreadystatechange = function () {
          if (request.readyState === 4) finish(request.status === 202);
        };
        request.onerror = request.ontimeout = function () { finish(false); };
        try { request.send(JSON.stringify(payload)); } catch (error) { finish(false); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
